<script lang="ts" setup>
import { DropdownButtonProps } from "~/components/Filters/Utils/DropdownButton.props"

withDefaults(defineProps<DropdownButtonProps>(), {
  nFilters: 0,
  opened: false
})

const emit = defineEmits<{ (e: "onClick"): void }>()
</script>

<template>
  <button
    v-if="!!text"
    type="button"
    class="
      filter-dropdown-button
      pig-medium
      relative
      flex
      items-center
      py-2
      pl-2
      pr-1
      after:absolute
      after:bottom-0
      after:left-1/2
      after:inline-block
      after:h-[2px]
      after:w-full
      after:-translate-x-1/2
      after:scale-x-0
      after:bg-green-main
      after:transition-transform
      hover:after:scale-x-100
    "
    :class="{ 'after:scale-x-100': opened }"
    @click="emit('onClick')"
  >
    <span class="mr-2">{{ text }}</span>
    <BadgeCounter v-if="!!nFilters" :counter="nFilters" />
    <UtilsIcon
      name="ChevronDown.svg"
      class="h-6 w-6 transition-transform duration-300"
      :class="{ 'rotate-x-180': opened }"
    />
  </button>
</template>
